import React from "react";
const Display = (props) => {
  return <div id="display">{props.clipName}</div>;
};
export default Display;
